
import { defineComponent, SetupContext, PropType } from "vue";
import NativeClient from "@/client/native-client";
import { PantryImageSelectData, FRIDGE_ROOM_ID_TYPE } from "@/types/pantry";
import PantryImageSelectItem from "./PantryImageSelectItem.vue";

export default defineComponent({
  name: "PantryImageSelectView",
  components: {
    PantryImageSelectItem
  },
  props: {
    selectRoomId: {
      type: Number,
      defalut: 0,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    // バナー一覧ダミー
    const selectList: Array<PantryImageSelectData> = [
      {
        id: FRIDGE_ROOM_ID_TYPE.DOOR,
        name: "ドア"
      },
      {
        id: FRIDGE_ROOM_ID_TYPE.FRIDGE,
        name: "冷蔵室"
      },
      {
        id: FRIDGE_ROOM_ID_TYPE.VEGETABLE,
        name: "野菜室"
      },
      {
        id: FRIDGE_ROOM_ID_TYPE.FREEZER,
        name: "冷凍室"
      }
    ];
    const onSelectRoom = (id: number) => {
      context.emit("select-room", id);
    };
    return {
      selectList,
      onSelectRoom,
    }
  }
});
